"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredicateStringParser = void 0;
const Predicate_1 = require("../Predicate");
const ParenthesisOpen_1 = require("./string-elements/ParenthesisOpen");
const OperatorString_1 = require("./string-elements/OperatorString");
const AtomicPredicateString_1 = require("./string-elements/AtomicPredicateString");
const PredicateStringElementParser_1 = require("./PredicateStringElementParser");
const NotString_1 = require("./string-elements/NotString");
const ParenthesisClose_1 = require("./string-elements/ParenthesisClose");
// noinspection JSMethodCanBeStatic
class PredicateStringParser {
    fromString(stringifiedPredicate, config) {
        const stringElementParser = new PredicateStringElementParser_1.PredicateStringElementParser(stringifiedPredicate, config);
        const stringElements = stringElementParser.parseStringElements();
        return this.createPredicateFromElementList(stringElements, config);
    }
    createPredicateFromElementList(elements, config, isNegated = false) {
        const children = [];
        let operator;
        let negated = isNegated;
        this.insertImplicitParenthesisIfNecessary(elements);
        let element = elements.asLinkedList();
        while (element) {
            if (element instanceof AtomicPredicateString_1.AtomicPredicateString) {
                children.push(element.getPredicate(config));
            }
            if (element instanceof OperatorString_1.OperatorString) {
                operator = element.getOperator();
            }
            if (element instanceof ParenthesisOpen_1.ParenthesisOpen) {
                const areChildrenNegated = element.getPrevious() instanceof NotString_1.NotString;
                const childPredicates = this.createPredicateFromElementList(element.getParenthesisContent(), config, areChildrenNegated);
                children.push(childPredicates);
                element = element.getClosingParenthesis();
            }
            element = element.getNext();
        }
        return new Predicate_1.Predicate({
            type: 'COMPLEX',
            isNegated: negated,
            operator,
            children,
        });
    }
    insertImplicitParenthesisIfNecessary(elements) {
        if (!elements.containsDifferentOperatorStrings()) {
            return elements;
        }
        let element = elements.asLinkedList();
        while (element) {
            if (element instanceof OperatorString_1.OperatorString && element.getOperator() === 'AND') {
                this.wrapWithParentheses(element, elements);
            }
            element = element.getNext();
        }
    }
    wrapWithParentheses(operatorString, stringElementCollection) {
        const leftHandElements = operatorString.getLeftHandOperand();
        const rightHandElements = operatorString.getRightHandOperand();
        const firstWrappedElement = leftHandElements[0];
        const lastWrappedElement = rightHandElements[rightHandElements.length - 1];
        stringElementCollection.wrap(new ParenthesisOpen_1.ParenthesisOpen(operatorString.getNestingIndex(), '('), firstWrappedElement, lastWrappedElement, new ParenthesisClose_1.ParenthesisClose(operatorString.getNestingIndex(), ')'));
    }
}
exports.PredicateStringParser = PredicateStringParser;
//# sourceMappingURL=PredicateStringParser.js.map